import React from 'react';

const ThemeToggle = ({ theme, onToggle }) => {
	const nextLabel = theme === 'v2' ? '🖥️ OS Mode' : '🎮 Game Mode';

	return (
		<button
			onClick={onToggle}
			className="font-mono text-xs px-3 py-1.5 rounded border border-gold/50 text-gold hover:bg-gold/10 hover:border-gold transition-colors whitespace-nowrap"
		>
			{nextLabel}
		</button>
	);
};

export default ThemeToggle;
